
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uxcore-api",
      function () {
        return require("private-next-pages/uxcore-api/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uxcore-api"])
      });
    }
  